
  import { defineComponent, ref, onMounted } from 'vue';
  import { useI18n } from 'vue-i18n/index';
  import { useStore } from 'vuex';
  import { useAbility } from '@casl/vue';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import { setCurrentPageBreadcrumbs } from '@/core/helpers/breadcrumb';
  import { Actions } from '@/store/enums/StoreEnums';
  import { AutoSyncTaskObject } from '@/store/modules/Indices/AutoSyncModule';

  export default defineComponent({
    name: 'auto-sync-pipeline',
    setup() {
      const { t, te } = useI18n();
      const store = useStore();
      const { can } = useAbility();

      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      onMounted(() => {
        setCurrentPageBreadcrumbs(translate('autoSyncPipeline'), [
          translate('indices'),
        ]);
      });

      const loading = ref(false);
      const lastTask = ref<AutoSyncTaskObject | null>(null);

      const runSync = async () => {
        if (loading.value || !can('update', 'indices')) return;

        const result = await Swal.fire({
          title: translate('areYouSureQ'),
          icon: 'warning',
          text: translate('confirmRunAutoSync'),
          showCancelButton: true,
          buttonsStyling: false,
          confirmButtonText: translate('confirm'),
          cancelButtonText: translate('cancel'),
          customClass: {
            confirmButton: 'btn fw-bold btn-warning',
            cancelButton: 'btn btn-light',
          },
        });
        if (!result.value) return;

        loading.value = true;
        try {
          const task = await store.dispatch(Actions.RUN_AUTO_SYNC);
          const error = store.getters.getErrors.autoSync;

          if (error) {
            Swal.fire({
              text: translate(error[0]),
              icon: 'error',
              buttonsStyling: false,
              confirmButtonText: translate('tryAgainExcl'),
              customClass: {
                confirmButton: 'btn fw-bold btn-light-danger',
              },
            });
            return;
          }

          lastTask.value = task;
          Swal.fire({
            text: translate('autoSyncStarted'),
            icon: 'success',
            buttonsStyling: false,
            confirmButtonText: translate('ok'),
            customClass: {
              confirmButton: 'btn btn-light-primary',
            },
          });
        } finally {
          loading.value = false;
        }
      };

      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading-over');

      return {
        translate,
        can,
        loading,
        lastTask,
        runSync,
      };
    },
  });
